<div class="card h-100" style="max-width: 300px;"
  [ngClass]="{'event-closed': event.closed}">
  <div class="card-header">
    <div class="d-flex">
      {{ leagueLabel(event.league) }}: <b class="ms-1">{{ event.event_name }}</b>
      @if (event.closed) {
        <i class="bi bi-lock-fill ms-auto"></i>
      }
    </div>
  </div>
  <a [routerLink]="['/home', 'events', event.league, event.uuid]">
    @if (event.image_content == undefined) {
      <img
        src="assets/sf-logo-start-2022.png"
        class="card-img-top rounded-4 event-img p-2 mx-auto" alt="...">
    }
    @if (event.image_content !== undefined) {
      <img
        [src]="event.image_content"
        class="card-img-top rounded-4 event-img p-2 mx-auto" alt="...">
    }
  </a>
  <div class="card-body" style="word-wrap: break-word;">
    <p class="card-text"><small class="text-muted">
      <i class="bi bi-clock"></i> {{ event.deadline | spotfightDateFormat }}</small></p>
      <p class="card-text">{{ event.description }}</p>
    </div>
    <div class="card-footer d-flex d-row justify-content-end">
      <button class="btn btn-primary"
        [routerLink]="['/home', 'events', event.league, event.uuid]">
        Öffnen
      </button>
    </div>
  </div>
